import { render } from "./ProductAccordion.vue?vue&type=template&id=bf3414ce&scoped=true"
import script from "./ProductAccordion.vue?vue&type=script&lang=js"
export * from "./ProductAccordion.vue?vue&type=script&lang=js"

import "./ProductAccordion.vue?vue&type=style&index=0&id=bf3414ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf3414ce"]])

export default __exports__